const mixinRerender = {
  data() {
    return {
      renderComponent: true,
    };
  },


  methods: {
    forceRerender() {
      // remove the my-component component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // add my-component component in DOM
        this.renderComponent = true;
      });
    },
  },

};

export default mixinRerender;
